import { useCallback, useEffect, useRef, useState } from 'react';
import { exchangeAdminSession } from '../services/adminAuthService';

export const useAdminAuthCallback = (sessionId, onComplete) => {
  const started = useRef(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!sessionId || started.current) return;
    started.current = true;

    const exchange = async () => {
      const result = await exchangeAdminSession(sessionId);
      if (result.ok) {
        onComplete(result.data);
      } else {
        setError(result.error);
      }
    };
    exchange();
  }, [sessionId, onComplete]);

  const retry = useCallback(() => {
    window.history.replaceState({}, '', '/admin');
    window.location.reload();
  }, []);

  return { error, retry };
};
